import { AuthConfig } from '@auth0/auth0-angular';

export type Auth0AppConfig = {
  domain: string;
  clientId: string;
  audience: string;
};

export function getAuth0Config(config: Auth0AppConfig): AuthConfig {
  return {
    domain: config.domain,
    clientId: config.clientId,
    authorizationParams: {
      audience: config.audience,
    },
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
    // Confluenceでのログインで時間がかかる場合があるので、デフォルトの1分から3分に延長している
    // @see https://github.com/auth0/auth0-spa-js/blob/master/src/constants.ts#L7
    authorizeTimeoutInSeconds: 60 * 3,
  };
}
